









































































































import Vue from 'vue';
import { mapGetters } from 'vuex';

import { QuoteState } from '@/models/quote';

import { IFetchInvoicesParams } from '@/services/invoice';
import QuotePicker from '../quote-common/QuotePicker.vue';

export default Vue.extend({
  components: { QuotePicker },
  name: 'DocumentSearchFilter',

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      QuoteState,
      filterParams: {} as IFetchInvoicesParams
    };
  },

  computed: {
    ...mapGetters({
      invoiceStateList: 'invoice/getInvoiceStateVisuals'
    }),

    openValue: {
      get(): boolean {
        return this.open;
      },
      set(val: boolean) {
        if (val === this.open) return;
        this.$emit('update:open', val);
      }
    }
  },

  methods: {
    closeSearchFilterDialog() {
      this.openValue = false;

      // reset filter params back to empty object
      this.resetFilterParams();
    },

    resetFilterParams() {
      this.filterParams = {};
    },

    openSearchFilterDialog(params: IFetchInvoicesParams) {
      if (params.quotes__id != null) {
        this.filterParams.quotes__id = params.quotes__id;
      }

      if (params.state != null) {
        this.filterParams.state = params.state;
      }

      this.openValue = true;
    },

    save() {
      this.$emit('change', this.filterParams);
      this.closeSearchFilterDialog();
    }
  }
});
